import { Component, isDevMode, OnDestroy, OnInit } from '@angular/core';
import { errorHandlerFn, HttpServiceConstants } from '@kimaya/ngx-http-service';
import { CoreConstants, SnackBarService } from './core';
import { NavigationStart, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { VersionCheckService } from './version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */

  constructor(private router: Router,
              private snackBarService: SnackBarService,
              private title: Title,
              private matDialog: MatDialog, private versionCheckService: VersionCheckService) {
    HttpServiceConstants.errorHandler = this.httpErrorHandler;
  }

  ngOnInit(): void {
    // Hide all dialog when navigation start
    this.router.events
      .pipe(
        takeUntil(this._unsubscribeAll),
        filter(event => event instanceof NavigationStart),
      ).subscribe(() => {
      this.matDialog.closeAll();
    });


    this.title.setTitle(CoreConstants.applicationDetails.appName);
    if (!isDevMode()) {
      this.versionCheckService.initVersionCheck('version.json');
    }

  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  public httpErrorHandler: errorHandlerFn = (error) => {
    if (error.status === 400) {
      if (error.error?.message) {
        this.snackBarService.open(error.error.message, 'error');
      } else if (error.response?.message) { // multipart  api response
        this.snackBarService.open(error.response.message, 'error');
      }
    } else if (error.status === 500) {
      this.router.navigate(['/error/500']);
    }
  };
}
